module.exports = __webpack_public_path__ + "static/media/passed.d79b745b.png";